export enum PAGE_TYPE {
  MAIN,
  TAG,
  RUBRIC,
  PARTNERS,
  PARTNER,
}
